import React from "react";

const CtaSec = () => {
  return (
    <div className="container">
      <div className="cta-sec">
        <img src="/cta-bg.svg" alt="cta-bg" className="cta-bg" />
        <div className="row align-items-center">
          <div className="col-lg-6 col-12">
            <h2 className="sec-head white">
              Reach out to our team for inquiries or support.
            </h2>
          </div>
          <div className="col-lg-6 col-12">
            <div className="email-sub-wrapper">
              <input placeholder="Email Address" />
              <a href="mailto:info@videovision.io">
                <span>Subscribe</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CtaSec;
